import React, { useState, useRef, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Flex } from '@chakra-ui/react'
import { Step, Steps, useSteps } from 'chakra-ui-steps'
import { Button } from '../../UI'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import { useMutateProgram } from '../../../hooks/Programs/SupportInCaseOfDeathOfMember'
import {
  CreateNewFile,
  GetFormData,
  GetNotification,
  RelationshipList3
} from '../../../Utils'

const SupportInCaseOfDeathOfMember = ({ partner, program = null }) => {
  const refStepOne = useRef(null)
  const refStepTwo = useRef(null)
  const refStepThree = useRef(null)
  const { nextStep, prevStep, activeStep } = useSteps({
    initialStep: 0
  })

  const history = useHistory()
  const [stepOneForm, setStepOneForm] = useState({
    partnerRut: partner?.rut,
    partnerPhone: partner?.phone,
    partnerGrade: partner?.grade,
    partnerCode: partner?.code,
    partnerZone: partner?.zone,
    partnerPrefecture: partner?.prefecture,
    partnerEndowment: partner?.endowment
  })
  const [stepTwoForm, setStepTwoForm] = useState({})
  const [stepThreeForm, setStepThreeForm] = useState({})
  const [finalForm, setFinalForm] = useState({
    partnerId: partner?._id
  })
  const [state, setState] = useState(null)
  const { mutate, isLoading, reset } = useMutateProgram('CREATE')
  const {
    mutate: mutateUpdate,
    isLoading: isLoadingUpdate,
    reset: resetUpdate
  } = useMutateProgram('UPDATE')

  const steps = [
    {
      label: 1,
      content: (
        <StepOne
          stepOneForm={stepOneForm}
          setStepOneForm={setStepOneForm}
          refStepOne={refStepOne}
          next={nextStep}
        />
      )
    },
    {
      label: 2,
      content: (
        <StepTwo
          stepTwoForm={stepTwoForm}
          setStepTwoForm={setStepTwoForm}
          refStepTwo={refStepTwo}
          partner={partner}
          next={nextStep}
        />
      )
    },
    {
      label: 3,
      content: (
        <StepThree
          stepThreeForm={stepThreeForm}
          setStepThreeForm={setStepThreeForm}
          refStepThree={refStepThree}
          state={state}
        />
      )
    }
  ]

  const handleNext = () => {
    if (activeStep === 0) {
      refStepOne.current()
    }
    if (activeStep === 1) {
      refStepTwo.current()
    }
    if (activeStep === 2) {
      refStepThree.current()
    }
  }

  useEffect(() => {
    let jsonStepTwo = {}
    const beneficiariesHelped = []
    const arrayDocumentsBirthCertificate = []
    const arrayDocumentsMarriageCertificate = []
    const arrayDocumentsAccountBackup = []

    if (stepTwoForm?.beneficiaries?.length > 0) {
      stepTwoForm?.beneficiaries?.forEach((item) => {
        const {
          birthCertificate,
          marriageCertificate,
          addresseeAccountBackup,
          _id
        } = item

        if (birthCertificate) {
          if (Object.keys(birthCertificate).length > 0) {
            Object.values(birthCertificate).forEach((doc) => {
              const result = CreateNewFile(doc, _id)
              arrayDocumentsBirthCertificate.push(result)
            })
          }
        }
        if (marriageCertificate) {
          if (Object.keys(marriageCertificate).length > 0) {
            Object.values(marriageCertificate).forEach((doc) => {
              const resultMarriage = CreateNewFile(doc, _id)
              arrayDocumentsMarriageCertificate.push(resultMarriage)
            })
          }
        }
        if (addresseeAccountBackup) {
          if (Object.keys(addresseeAccountBackup).length > 0) {
            Object.values(addresseeAccountBackup).forEach((doc) => {
              const resultAccount = CreateNewFile(doc, _id)
              arrayDocumentsAccountBackup.push(resultAccount)
            })
          }
        }
      })

      const formaterStepTwo = stepTwoForm?.beneficiaries?.map((item) => {
        /* eslint-disable no-unused-vars */
        const {
          birthCertificate,
          marriageCertificate,
          addresseeAccountBackup,
          ...rest
        } = item

        return rest
      })
      jsonStepTwo = {
        beneficiariesData: JSON.stringify(formaterStepTwo)
      }

      if (formaterStepTwo.length > 0) {
        RelationshipList3.forEach((relationship) => {
          const totalPerBeneficiary = formaterStepTwo.filter(
            (item) => item?.relationship === relationship
          )

          if (totalPerBeneficiary.length > 0) {
            totalPerBeneficiary?.forEach((item) => {
              beneficiariesHelped.push(item.relationship)
            })
          }
        })
      }
    }

    setFinalForm({
      ...finalForm,
      ...stepOneForm,
      ...stepTwoForm,
      ...jsonStepTwo,
      arrayDocumentsBirthCertificate,
      arrayDocumentsMarriageCertificate,
      arrayDocumentsAccountBackup,
      ...stepThreeForm,
      beneficiariesHelped
    })
  }, [stepThreeForm])

  useEffect(() => {
    const test = true
    console.log(finalForm)

    if (test) {
      if (Object.keys(finalForm).length > 1 && activeStep === 2) {
        if (!program) {
          const formData = GetFormData(
            finalForm,
            [
              'deathCertificate',
              'salarySettlement',
              'additionalDocuments',
              'arrayDocumentsBirthCertificate',
              'arrayDocumentsMarriageCertificate',
              'arrayDocumentsAccountBackup'
            ],
            ['beneficiariesHelped']
          )

          mutate(formData, {
            onSuccess: () => {
              reset()
              GetNotification.basic('Programa registrado con Éxito', 'Aceptar')
              history.push('/programs')
            },
            onError: (err) => {
              console.log(err)
              GetNotification.basic(
                'Error',
                'Aceptar',
                'Error al Registrar programa',
                'error'
              )
            }
          })
        }

        if (program) {
          const { _id: programId } = program
          const formData = GetFormData(
            finalForm,
            [
              'deathCertificate',
              'salarySettlement',
              'additionalDocuments',
              'arrayDocumentsBirthCertificate',
              'arrayDocumentsMarriageCertificate',
              'arrayDocumentsAccountBackup'
            ],
            [
              'deathCertificateName',
              'salarySettlementName',
              'additionalDocumentsName',
              'beneficiariesHelped'
            ]
          )
          mutateUpdate(
            { programId, formData },
            {
              onSuccess: () => {
                resetUpdate()
                GetNotification.basic(
                  'Programa actualizado con Éxito',
                  'Aceptar'
                )
                history.push('/programs')
              },
              onError: (err) => {
                console.log(err)
                GetNotification.basic(
                  'Error',
                  'Aceptar',
                  'Error al actualizar programa',
                  'error'
                )
              }
            }
          )
        }
      }
    }
  }, [finalForm])

  useEffect(() => {
    if (program) {
      setStepOneForm({
        receptionDate: program?.receptionDate,
        isPartnerZone: program?.isPartnerZone,
        zone: program?.zone,
        prefecture: program?.prefecture,
        unit: program?.unit,
        dateOfDeath: program?.dateOfDeath,
        observations: program?.observations,
        /* partner field */
        partnerRut: program?.partner?.rut,
        partnerPhone: program?.partner?.phone,
        partnerGrade: program?.partner?.grade,
        partnerCode: program?.partner?.code,
        partnerZone: program?.partner.zone,
        partnerPrefecture: program?.partner.prefecture,
        partnerEndowment: program?.partner?.endowment
      })
      setStepTwoForm({
        beneficiaries: program?.beneficiaries?.map((item) => ({
          ...item,
          birthCertificateName: item?.birthCertificate,
          birthCertificate: null,
          marriageCertificateName: item?.marriageCertificate,
          marriageCertificate: null,
          addresseeAccountBackupName: item?.addresseeAccountBackup,
          addresseeAccountBackup: null
        }))
      })
      setStepThreeForm({
        deathCertificateName: program?.deathCertificate,
        salarySettlementName: program?.salarySettlement,
        additionalDocumentsName: program?.additionalDocuments
      })
    }
  }, [program])

  return (
    <Flex direction={'column'}>
      <Steps
        activeStep={activeStep}
        orientation="horizontal"
        responsive
        mb={{
          lg: 5,
          md: 0
        }}
      >
        {steps.map(({ label, content }) => (
          <Step key={label}>{content}</Step>
        ))}
      </Steps>
      <Flex justify={'flex-end'} mt={4}>
        <Button
          text={'Regresar'}
          bg={'green.50'}
          color={'green.500'}
          disabled={activeStep === 0 || isLoading || isLoadingUpdate}
          onClick={prevStep}
        />
        {activeStep === steps.length - 1 && (
          <Button
            text={'Guardar como incompleta'}
            bg={'green.50'}
            color={'green.500'}
            disabled={activeStep === 0 || isLoading || isLoadingUpdate}
            onClick={() => {
              setState('INCOMPLETE')
              handleNext()
            }}
            isLoading={isLoading || isLoadingUpdate}
          />
        )}
        <Button
          text={activeStep === steps.length - 1 ? 'Finalizar' : 'Siguiente'}
          onClick={() => {
            setState('INREVIEW')
            handleNext()
          }}
          isLoading={isLoading || isLoadingUpdate}
          disabled={isLoading || isLoadingUpdate}
        />
      </Flex>
    </Flex>
  )
}

export default SupportInCaseOfDeathOfMember
